import React from 'react'

const SubFooter = () => {
    return (
            <div className="FooterDivMain">
            <div></div>
            <div>
            <div className="footerDiv">
                <div className="leftFooterDiv">
                    <div className="socialIconsLink">
                        <i className="fab fa-facebook-square"></i>
                        <i className="fab fa-twitter"></i>
                        <i className="fab fa-instagram"></i>
                        <i className="fab fa-pinterest-p"></i>
                        <i className="fab fa-linkedin-in"></i>
                    </div>

                    <div className="socialIconsLinkDown">
                        <h2>LivLife</h2>
                        <p>Mumbai, India</p>
                        <small>500909</small>
                    </div>
                </div>

                <div className="rightFooterDiv">
                    <div className="aboutFooterDiv">
                        <h1>About</h1>
                        <ol>
                            <li>HTML</li>
                            <li>HTML</li>
                            <li>HTML</li>
                            
                        </ol>
                    </div>

                    <div className="servicesFooterDiv">
                        <h1>Services</h1>
                        <ol>
                            <li>CSS</li>
                            <li>CSS</li>
                            <li>CSS</li>
                            
                        </ol>
                    </div>

                    <div className="usefulLinksFooter">
                        <h1>Details</h1>
                         <ol>
                            <li>JavaScript</li>
                            <li>JavaScript</li>
                            <li>JavaScript</li>
                            
                        </ol>
                    </div>
                </div>
            </div>   
            <p id='footerDivLine'>If you are in a life threatening situation - don’t use this site. Call +1 (800) 273-8255 or use these resources to get immediate help.</p>
            </div>             
        </div>
    )
}

export default SubFooter
